export default __webpack_public_path__ + "static/media/bookmarked-updated-gif.3192d030.gif";